export var STATES_MAIN;
(function (STATES_MAIN) {
    STATES_MAIN["LANDING"] = "landing";
    STATES_MAIN["START"] = "start";
    STATES_MAIN["TOUR"] = "tour";
    STATES_MAIN["FIRST_VISIT"] = "firstVisit";
})(STATES_MAIN || (STATES_MAIN = {}));
export var STATES_LANDING;
(function (STATES_LANDING) {
    STATES_LANDING["AUTHENTICATING_APP"] = "authenticatingApp";
    STATES_LANDING["AUTHENTICATE_APP_SUCCESS"] = "authenticatingAppSuccess";
    STATES_LANDING["AUTHENTICATE_APP_FAILED"] = "authenticateAppFailed";
    STATES_LANDING["AGREED_TNC"] = "agreedTnc";
})(STATES_LANDING || (STATES_LANDING = {}));
export var STATES_START;
(function (STATES_START) {
    STATES_START["DEFAULT"] = "default";
    STATES_START["FLOOD_LIKELIHOOD"] = "floodLikelihood";
    STATES_START["FLOOD_RISK"] = "floodRisk";
    STATES_START["SEARCHING"] = "searching";
})(STATES_START || (STATES_START = {}));
export var STATES_TOUR;
(function (STATES_TOUR) {
    STATES_TOUR["DEFAULT"] = "default";
    STATES_TOUR["DONE"] = "done";
})(STATES_TOUR || (STATES_TOUR = {}));
export var STATES_FIRST_VISIT;
(function (STATES_FIRST_VISIT) {
    STATES_FIRST_VISIT["DEFAULT"] = "default";
    STATES_FIRST_VISIT["SEARCH"] = "search";
    STATES_FIRST_VISIT["SEARCHING"] = "searching";
})(STATES_FIRST_VISIT || (STATES_FIRST_VISIT = {}));
